import styled from '@emotion/styled';

export const Wrapper = styled.div<{ open: boolean }>`
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  padding: 8px 12px;
  border: 1px solid ${({ theme, open }) => (open ? theme.colors.neutral[700] : theme.colors.neutral[300])};
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.neutral[700]};
  }
`;

export const SelectedText = styled.span`
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.neutral[700]};
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ArrowWrapper = styled.button<{ open: boolean }>`
  transition: all 200ms ease;
  transform: ${({ open }) => (open ? 'rotate(0deg)' : 'rotate(-180deg)')};
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
`;

export const DropdownUl = styled.ul`
  position: absolute;
  display: flex;
  width: 100%;
  flex-direction: column;
  left: 0px;
  top: 44px;
  z-index: 10;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  padding: 4px;
`;

export const DropdownListWrapper = styled.li<{ selected: boolean }>`
  display: flex;
  height: 32px;
  padding: 6px 12px;
  border-radius: 4px;
  background-color: ${({ theme, selected }) => (selected ? theme.colors.neutral[200] : theme.colors.neutral[0])};

  &:hover {
    background-color: ${({ theme, selected }) => !selected && theme.colors.neutral[100]};
  }
`;

export const DropdownListLabel = styled.span`
  color: ${({ theme }) => theme.colors.neutral[700]};
  font-size: 14px;
  line-height: 18px;
`;
